module.exports = __webpack_public_path__ + "static/media/curved-6.1ba3792d.jpg";